import { onReady } from './onReady';
import { resolveSymbol } from './resolveSymbol';
// 1. Add resetReplay to this line
import { getBars, subscribeBars, unsubscribeBars, resetReplay } from './getBars';

// ✅ Required by TradingView v31
const searchSymbols = (userInput, exchange, symbolType, onResultReadyCallback) => {
  // We use a fixed symbol list, so we return empty search results
  onResultReadyCallback([]);
};

const Datafeed = {
  onReady,
  searchSymbols,   // ✅ Required in v31
  resolveSymbol,
  getBars,
  subscribeBars,
  unsubscribeBars,
  resetReplay,
};

// 3. Add this line to pass the export through to the Chart Container
export { resetReplay };

export default Datafeed;